export default [
    {
      path: '/admin/restaurant-kdu',
      name: 'view-kdu',
      meta: { requiresAuth: true },
      component: () => import('@/pages/restaurant-sale/kdu')
    }
  ]
  